module.exports = __webpack_public_path__ + "img/404-en.fbe4d1d.svg";